import React, { useEffect, useState } from "react";
import axios from "axios";
import "./index.css";
import { useUsersContext } from "../../../../../../context/usersContext";
import env from "../../../../../../config/env";
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";

import { loadStripe } from "@stripe/stripe-js";

const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const AddNewCardModal = ({ isModalOpen, justCloseIt, getLocationUsers }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [processing, setProcessing] = useState(false);
  const element = useElements();
  const stripe = useStripe();
  // prompt payload states
  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const [userRole, setUserRole] = useState();

  // error status
  const [userNameError, setUserNameError] = useState(null);
  const [userEmailError, setUserEmailError] = useState(null);
  const [userRoleError, setUserRoleError] = useState(null);
  const [isChecked, setIsChecked] = useState(null);

  const handleToggle = () => {
    const name = isChecked === "primary" ? null : "primary";
    setIsChecked(name);
  };

  const resetAddUserForm = () => {
    setUserName("");
    setUserEmail("");
    setUserRole("");
  };
  useEffect(() => { }, []);
  const handleClose = () => {
    justCloseIt();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // setProcessing(true);

    // var make_default = event.target.switch.checked;
    // var name = event.target.name.value;
    if (element == null) {
      return;
    }
    let paymentMethod = {};
    // const source = await stripe.createSource(element.getElement(CardElement));
    paymentMethod = await stripe.createPaymentMethod({
      type: "card",
      card: element.getElement(CardElement),
    });

    // 4848 7150 5203 7927


    const data = {
      // name: name,
      email: "user.email",
      phone: "user.phone",
      make_default: true,
      paymentMethod: paymentMethod.paymentMethod,
      agency_id: "dfd",
    };

    const payload = {
      data: data,
    };
    // return 0;
    if (paymentMethod.error) {
      // seterror(paymentMethod.error.message)
      // handleClose();
    } else {
      if ("agency_stripe" == null) {
        const { response, error } = await axios.post("endpoint", { payload });
        if (response) {
          setProcessing(false);

          // handlemessage(response.message, "success");
          // handleRefresh();
          // onClose();
        } else {
          setProcessing(false);

          // handlemessage(error.response.message, "error");
          // onClose();
        }
      } else {
        const { response, error } = await axios.put("", {
          payload,
          id: "dfd",
        });
        if (response) {
          setProcessing(false);

          // handlemessage(response.message, "success");
          // handleRefresh();
          // onClose();
        } else {
          setProcessing(false);

          // handlemessage(error.response.message, "error");
          // onClose();
        }
        // axios
        //   .post(
        //     BASE_URL + "/snapshot/agency/stripe/update/" + agency_stripe._id,
        //     { data }
        //   )
        //   .then(async function (response) {

        //     // setmessage(response.data.message)
        //     // seterror('')
        //     setProcessing(false);

        //     handlemessage(response.data.message, "success");
        //     handleRefresh();
        //     onClose();
        //     // handleClose();
        //   })
        //   .catch(function (error) {
        //     // handleClose();
        //     setProcessing(false);
        //     handlemessage(error.response.data.message, "error");
        //     onClose();
        //     // setmessage('')
        //     // seterror(error.response.data.message)
        //   });
      }
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content">
          <div style={{ position: "relative" }}>
            <p
              style={{
                position: "absolute",
                right: 0,
                width: "12px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              X
            </p>
            <p className="modalText">Add New Card</p>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <CardElement />
            </div>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label>Name on Card</label>
              </div>
              <input
                type="text"
                name="userEmail"
                placeholder="Name on Card"
                className="flex-1 modalInputs"
                value={userEmail}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                  setUserEmailError(null);
                }}
              />
              {userEmailError && (
                <small className="text-destructive">{userEmailError}</small>
              )}
            </div>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label>Make Primary</label>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={isChecked}
                    onChange={handleToggle}
                  />
                  <div className="relative w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>

              {userEmailError && (
                <small className="text-destructive">{userEmailError}</small>
              )}
            </div>
            <p
              className="disagreeBtn"
              style={{
                margin: 0,
                width: "100%",
                opacity: processing ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={processing}
              onClick={handleSubmit}
            >
              {processing && <div className="spinner"></div>}
              Save
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddNewCardModal;
